module.exports = __webpack_public_path__ + "img/gemini.26c71576.svg";